import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import Button from 'PyzShopUi/scripts/react/common/components/form/Button';
import {
    beginGetProductReviewLoading,
} from 'PyzShopUi/scripts/product-review/actions/getReview';
import {
    ISetPaginationPayload,
    setPagination
} from 'PyzShopUi/scripts/shop-ui/components/search-page/actions/pagination';

interface ILoadMoreProps {
    currentPage: number
    maxPage: number
    dispatch: React.Dispatch<any>
    isProgressing: boolean
}

const LoadMore: React.FunctionComponent<ILoadMoreProps> = props => {

    const { currentPage, maxPage, dispatch, isProgressing} = props;
    const hasNextPage = currentPage < maxPage;
    const { translate } = useTranslationHook();

    const onLoadMoreHandler = (event: Event) => {
        event.preventDefault();
        if (!hasNextPage) {
            return;
        }
        dispatch(beginGetProductReviewLoading());
        const payload: ISetPaginationPayload = {
            page: (currentPage + 1).toString()
        };
        dispatch(setPagination(payload));
    }

    if (!hasNextPage) {
        return null
    }
    return (
        <div>
            <Button
                label={translate('Show more reviews', { ns: 'article-detail' })}
                isBordered={true}
                color={'grey'}
                icon={'arrow'}
                iconPosition={'right'}
                isDisabled={isProgressing}
                onClick={onLoadMoreHandler}
            />
        </div>
    );
};

export default LoadMore;
